export const ATTENDANCE_REPORT_COLUMN = {
  STUDENT_NAME: 'Student Name',
  STUDENT_ID: 'Student ID',
  EMAIL: 'Email',
  PHONE: 'Phone',
  STUDENT_SINCE_DATE: 'Student Since Date',
  TOTAL_LIFETIME_ATTENDANCE: 'Total Lifetime Attendance',
  ATTENDANCE_LAST_30_DAYS: 'Attendance Last 30 Days',
  TOTAL_ABSENCES: 'Total Absences',
  ABSENCES_IN_SELECTED_DATE_RANGE: 'Absences In Selected Date Range',
  LAST_ATTENDED_CLASS: 'Last Attended Class',
  LAST_ATTENDANCE_DATE: 'Last Attendance Date',
  LAST_ATTENDANCE_TIME: 'Last Attendance Time',
  UPCOMING_SCHEDULED_CLASS: 'Upcoming Scheduled Class',
  UPCOMING_SCHEDULED_DATE: 'Upcoming Scheduled Date',
  UPCOMING_SCHEDULED_TIME: 'Upcoming Scheduled Time',
} as const;

export interface AttendanceReportRow {
  studentName: string;
  studentId: string;
  email: string;
  phone: string;
  studentSinceDate: string;
  lifetimeAttendance: number;
  attendanceLast30Days: number;
  totalAbsences: number;
  absencesInRange: number | null;
  lastAttendedClass: string;
  lastAttendanceDate: string;
  lastAttendanceTime: string;
  upcomingScheduledClass: string;
  upcomingScheduledDate: string;
  upcomingScheduledTime: string;
}

export interface AttendanceReportAbsenceRange {
  start: string;
  end: string;
}

export interface AttendanceReportData {
  studioName: string;
  absenceRange?: AttendanceReportAbsenceRange | null;
  rows: Array<AttendanceReportRow>;
}

export interface AttendanceReportRangeParams {
  startDate?: string;
  endDate?: string;
}
